<template>
  <article>
    <div :class="[useCncycd? 'form-multi-group--type2':'form-row']">
      <div v-if="useCncycd">
        <select-box
          ref="cncycd"
          :value.sync="cncycdData"
          :option-list.sync="cncycdList"
          v-show="_.isNil(cncycdList) || cncycdList.length > 1"
        />
        <span class="unit" v-if="!_.isNil(cncycdList) && cncycdList.length == 1">{{cncycdData}}</span>
      </div>
      <!-- 1007 left 옵션 추가 -->
      <div v-if="!useCncycd && !isLoan" class="item-tit">{{ /*입금 금액*/ $t("MPAY-01-01-08-04")}}</div>
      <template v-if="useCncycd">
        <div>
          <div required="required">
            <div class="form-text-field number">
              <div class="input-text-field">
                <span v-if="!useCncycd" class="unit">{{cncycdData}}</span>
                <input-text
                  ref="amount"
                  id="amount"
                  :value.sync="amountData"
                  :placeholder="'0'"
                  :numericComma="`${$config.SITECODE_OGMMR}|${$config.SITECODE_OGCBD}|${$config.SITECODE_OGIND}|${$config.SITECODE_OGAUC}`"
                  :numeric="`${$config.SITECODE_OGHCM}`"
                  required
                  :maxlength="19"
                  :err-msg-param="{filed:$t('MCOM-0000074'), max:19}"
                  :custom-error.sync="customError"
                  :use-right-icon="false"
                  :cncycd="cncycdData"
                />
              </div>
            </div>
            <div v-if="customError" class="validate">
              <slot name="customErrorMsg" />
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="item-desc">
          <div class="form-text-field unit-number">
            <div class="form-multi-group--type2">
              <span v-if="!useCncycd" class="unit">{{cncycdData}}</span>
              <input-text
                ref="amount"
                id="amount"
                :value.sync="amountData"
                :placeholder="'0'"
                :numericComma="`${$config.SITECODE_OGMMR}|${$config.SITECODE_OGCBD}|${$config.SITECODE_OGIND}|${$config.SITECODE_OGAUC}`"
                :numeric="`${$config.SITECODE_OGHCM}`"
                required
                :maxlength="19"
                :err-msg-param="{filed:$t('MCOM-0000074'), max:19, maxValue:maxValue}"
                :custom-error="customError"
                :css-hide="false"
                :maxValue="maxValue"
                :use-right-icon="false"
                :cncycd="cncycdData"
              >
                <template #error>
                  <slot name="customErrorMsg" />
                </template>
              </input-text>
            </div>
          </div>
        </div>
      </template>
    </div>
  </article>
</template>
<script>
export default {
  props: {
    //true:예금신규, false:자동이체등록
    useCncycd: {
      type: Boolean,
      default: true,
    },
    //true:대출상환
    isLoan: {
      type: Boolean,
      default: false,
    },
    cncycd: String,
    amount: {
      default: "",
    },
    customError: {
      type: Boolean,
      default: false,
    },
    maxValue: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      cncycdList: [],
      isError: false,
    };
  },
  computed: {
    cncycdData: {
      get() {
        return this.cncycd;
      },
      set(value) {
        this.$emit("update:cncycd", value);
      },
    },
    amountData: {
      get() {
        return this.amount;
      },
      set(value) {
        this.$emit("update:amount", value);
      },
    },
  },
  created() {
    if (this.useCncycd) {
      this.$emit("cncycdListSet");
    }
  },
  methods: {
    setCncycdList(list) {
      this.$refs.cncycd.setOptionList(list);
    },
    invalid() {
      return this.customError || this.$refs.amount.$v.$invalid;
    },
    getAmount() {
      return this.$removeComma(this.amountData);
    },
  },
};
</script>